/**
 * Whether a router state carries something to start a quote from (a ticket, a unit, a CRM lead or a project). Kept apart
 * from prefill.ts so the worksheet gate, which the quoting routes load eagerly, does not pull prefill's ticket and
 * generator hooks into the routes' import graph (check-import-graph: that edge closed a load-time cycle).
 */
export function hasQuoteSource(state: unknown): boolean {
  const s = state as {
    ticket?: unknown;
    equipment?: unknown;
    worksheetEquipment?: unknown;
    fromLead?: unknown;
    project?: unknown;
  } | null | undefined;
  return Boolean(s && (s.ticket || s.equipment || s.worksheetEquipment || s.fromLead || s.project));
}
